import React from 'react'

const IconChart = (props) => {
  return (
    <svg {...props} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M2 29L11 20L15.5 24.5L20 17.75L26.75 29L33.5 8.75H38" stroke="currentcolor" strokeWidth="2" strokeLinejoin="round"/>
    <path d="M2 38V2H38V38H2Z" stroke="currentcolor" strokeWidth="2" strokeLinejoin="round"/>
    </svg>
  )
}

export default IconChart